import {
  DC_Repositories_Base_Enumerations_BusinessUnit,
  DC_Repositories_Base_Enumerations_Label,
  RequestModels_NextBestAction_ActionFeedbackDataRequestModel,
  ResponseModels_NextBestAction_NextBestActionResponseModel,
} from '@monorepo-types/dc';

import { request } from '../client';
import type { ApiRequestConfig } from '../client/types';

type GetNextBestActionsPublic = {
  businessUnit: DC_Repositories_Base_Enumerations_BusinessUnit;
  label: DC_Repositories_Base_Enumerations_Label;
  personalizationId: string;
  servingPointId?: number;
};
/**
 * Get Next Best Actions
 *
 * @returns ResponseModels_NextBestAction_NextBestActionResponseModel Success
 */
export function getNextBestActionsPublic(
  { businessUnit, label, personalizationId, servingPointId }: GetNextBestActionsPublic,
  requestConfig: ApiRequestConfig = {},
): Promise<ResponseModels_NextBestAction_NextBestActionResponseModel> {
  return request(
    {
      method: 'GET',
      path: `/dxpweb/public/${businessUnit}/${label}/nextbestaction/${personalizationId}`,
      query: { servingPointId },
      errors: { 400: 'Bad Request', 404: 'Not Found' },
    },
    requestConfig,
  );
}

type PutNextBestActionFeedbackPublic = {
  businessUnit: DC_Repositories_Base_Enumerations_BusinessUnit;
  label: DC_Repositories_Base_Enumerations_Label;
  personalizationId: string;
  requestBody: RequestModels_NextBestAction_ActionFeedbackDataRequestModel;
};
/**
 * Put Next Best Action Feedback
 *
 * @returns any Success
 */
export function putNextBestActionFeedbackPublic(
  { businessUnit, label, personalizationId, requestBody }: PutNextBestActionFeedbackPublic,
  requestConfig: ApiRequestConfig = {},
): Promise<any> {
  return request(
    {
      method: 'PUT',
      path: `/dxpweb/public/${businessUnit}/${label}/nextbestaction/${personalizationId}/feedback`,
      body: requestBody,
      errors: { 400: 'Bad Request', 404: 'Not Found' },
    },
    requestConfig,
  );
}
